export default __webpack_public_path__ + "static/media/banner-xl-900px.b2e0d9df.png";